import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowLeftSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m6.407 8 4.297-4.297L9.29 2.289 3.579 8l5.71 5.711 1.415-1.414L6.407 8Z"
    />
  </svg>
);
export default IconArrowLeftSizeS;
